export default __webpack_public_path__ + "img/x-circle-grey.ec84b1b6.svg";